interface LandingPageProps {
  onStart: () => void;
}

export function LandingPage({ onStart }: LandingPageProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 px-4 py-12 max-w-2xl mx-auto w-full flex flex-col justify-center">

        {/* Afsender */}
        <p className="text-sm font-medium text-brand uppercase tracking-widest mb-8">
          Drømmevillaen
        </p>

        {/* Overskrift */}
        <h1 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight mb-6">
          Du bygger sandsynligvis for dyrt — uden at vide det
        </h1>

        <p className="text-lg text-gray-600 mb-10">
          De fleste boligbyggere efterlader hundredtusindvis af kroner på bordet,
          fordi de ikke kender de rigtige greb. På 3 minutter viser vi dig præcist
          hvad dit projekt kan optimeres med — helt gratis og uvildig.
        </p>

        {/* Hvad du får */}
        <div className="space-y-4 mb-10">
          {[
            {
              ikon: '📊',
              titel: 'Et realistisk besparelsesinterval',
              tekst: 'Ikke tomme løfter — konkrete kroner baseret på dit specifikke budget og situation.',
            },
            {
              ikon: '🎯',
              titel: 'De tre områder du bør fokusere på',
              tekst: 'Du får at vide præcis hvor dit projekt har størst optimeringspotentiale.',
            },
            {
              ikon: '🎧',
              titel: 'Podcast-afsnit målrettet dig',
              tekst: 'Lær fra rigtige byggeprojekter — vi anbefaler de afsnit der er mest relevante for dine svar.',
            },
          ].map(({ ikon, titel, tekst }) => (
            <div key={titel} className="flex gap-4 p-4 rounded-xl bg-white border border-gray-100">
              <span className="text-2xl leading-none mt-0.5" aria-hidden="true">{ikon}</span>
              <div>
                <p className="font-semibold text-gray-900 mb-0.5">{titel}</p>
                <p className="text-sm text-gray-500">{tekst}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Sådan virker det */}
        <div className="mb-10">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
            Sådan virker det
          </p>
          <ol className="space-y-2">
            {[
              'Svar på 7 korte spørgsmål om din byggeproces',
              'Angiv dit samlede byggebudget',
              'Få dit personlige resultat med det samme',
            ].map((trin, i) => (
              <li key={trin} className="flex items-center gap-3 text-sm text-gray-600">
                <span
                  className="flex-shrink-0 w-6 h-6 rounded-full bg-brand text-white
                    text-xs font-bold flex items-center justify-center"
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                {trin}
              </li>
            ))}
          </ol>
        </div>

        {/* CTA */}
        <button
          type="button"
          onClick={onStart}
          className="w-full py-5 px-6 rounded-xl bg-brand text-white text-lg font-semibold
            hover:bg-brand-600 active:bg-brand-700 transition-colors
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
        >
          Beregn mit optimeringspotentiale →
        </button>

        {/* Tillid */}
        <p className="text-center text-sm text-gray-400 mt-4">
          Gratis · Uvildigt · Ingen spam · Dine data deles aldrig
        </p>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-100 py-6 text-center text-xs text-gray-400">
        <p>Playground Institute ApS — CVR 36406356</p>
      </footer>
    </div>
  );
}
